"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
exports.__esModule = true;
exports.InRoomEntertainmentAmenitiesDto = void 0;
var class_validator_1 = require("class-validator");
var InRoomEntertainmentAmenitiesDto = (function () {
    function InRoomEntertainmentAmenitiesDto() {
    }
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsBoolean(),
        __metadata("design:type", Boolean)
    ], InRoomEntertainmentAmenitiesDto.prototype, "television");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsIn(['TELEVISION', 'FLAT_PANEL_TV', 'LCD_TV', 'LED_TV', 'SMART_TV']),
        __metadata("design:type", String)
    ], InRoomEntertainmentAmenitiesDto.prototype, "televisionType");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsNumber(),
        class_validator_1.Min(0),
        __metadata("design:type", Number)
    ], InRoomEntertainmentAmenitiesDto.prototype, "televisionSize");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsBoolean(),
        __metadata("design:type", Boolean)
    ], InRoomEntertainmentAmenitiesDto.prototype, "dvdPlayer");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsBoolean(),
        __metadata("design:type", Boolean)
    ], InRoomEntertainmentAmenitiesDto.prototype, "iPodDocStation");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsBoolean(),
        __metadata("design:type", Boolean)
    ], InRoomEntertainmentAmenitiesDto.prototype, "mp3DocStation");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsBoolean(),
        __metadata("design:type", Boolean)
    ], InRoomEntertainmentAmenitiesDto.prototype, "videoGameConsole");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsBoolean(),
        __metadata("design:type", Boolean)
    ], InRoomEntertainmentAmenitiesDto.prototype, "computerOrTablet");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsIn(['COMPUTER', 'TABLET', 'IPAD']),
        __metadata("design:type", String)
    ], InRoomEntertainmentAmenitiesDto.prototype, "computerType");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsArray(),
        class_validator_1.IsIn(['NETFLIX', 'PREMIUM_CHANNELS', 'PAY_MOVIES', 'FIRST_RUN_MOVIES'], {
            each: true
        }),
        __metadata("design:type", Array)
    ], InRoomEntertainmentAmenitiesDto.prototype, "channels");
    return InRoomEntertainmentAmenitiesDto;
}());
exports.InRoomEntertainmentAmenitiesDto = InRoomEntertainmentAmenitiesDto;
//# sourceMappingURL=in-room-entertainment-amenities.dto.js.map